/* eslint-disable max-len */
export const dictionary = {
  AlertSendCode: 'Enviamos um código de verificação no seu e-mail. Caso você não receba o e-mail em alguns minutos, verifique a sua caixa de spam ou repita o processo.',
  AlertSendCodeError: 'Ops.. Não encontramos sua conta. Verifique se o e-mail digitado está correto',
  AlertUserNotVerify: 'É necessário confirmar este usuário antes de tentar recuperar a senha',
  PasswordUpdatedSuccess: 'Nova senha cadastrada com sucesso',

  CodeMismatchException: 'Código de verificação inválido, tente novamente',
  NotAuthorizedException: 'E-mail e/ou senha incorretos.',
  NotAuthorizedExceptionTempPasswordExpired: 'A senha temporária expirou e deve ser redefinida por um administrador',
  UsernameExistsException: 'Já existe uma conta com o email informado',
  UserNotConfirmedException: 'Usuário não confirmado',
  UserNotFoundException: 'E-mail e/ou senha incorretos',
  ExpiredCodeException: 'Código inválido/expirado',
  LimitExceededException: 'Limite de tentativas excedidas, tente novamente mais tarde',
  DefaultException: 'Inconsistência nos dados enviados, tente novamente mais tarde',
  UserSuccessfullyVerified: 'Usuário verificado com sucesso',
  NewPasswordRequired: 'Este é seu primeiro acesso, crie uma nova senha para acessar a plataforma',
  ResendSignUpSuccess: 'Código enviado com sucesso',
  ResendSignUpFail: 'Erro ao enviar código',
  NotAuthorizedSocial: 'Não foi possível autenticar com sua conta social. Verifique se o e-mail de sua conta social é o mesmo e-mail criado utilizado na Gaiz na criação da conta. Verifique o e-mail utilizado em nossa plataforma acessando o menu "Perfil"',
  NotAuthorizedSocialEmail: 'Não foi possível autenticar com sua conta social. Nosso sistema não pode recuperar o e-mail associado a sua conta social. Verifique as permissões em sua conta social e tente novamente.',
  ValidateInvalidEmail: 'E-mail inválido',
  ValidateRequiredField: 'Campo obrigatório',
  ValidateMaxPassword: 'Máximo de 24 caracteres',
  ValidateMinPassword: 'Mínimo de 8 caracteres',
  ValidateOneLowerChar: 'Pelo menos um caractere minúsculo',
  ValidateOneUpperChar: 'Pelo menos um caractere maiúsculo',
  ValidateOneNumber: 'Pelo menos um número',
  ValidateOneSpecialChar: 'Pelo menos um caracter especial',
  ValidatePasswordNotEquals: 'As senhas não são iguais',
  ValidateOnlyNumbers: 'Somente números'
}
